import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  resultCedula: [],
  currentCedula: {},
  estados: [],
  municipios: [],
  dataNotFound: [],
  countCedula: ''
};
export const mutations = {
  RESULT_CEDULAS({ context }, result_cedulas) {
    state.loading = false;
    // state.resultCedula = Object.assign({}, result_cedulas);
    if (result_cedulas) {
      let cedulas = [];
      Object.entries(result_cedulas).forEach(([key, val]) => cedulas.push(val));
      return (state.resultCedula = cedulas);
    }
  },
  COUNT_CEDULAS({ context }, count_cedulas) {
    return (state.countCedula = count_cedulas);
  },
  DATA_NOT_FOUND({ context }, data) {
    state.dataNotFound = data
  },
  SHOW_A_CEDULA({ context }, data) {
    state.loading = false;
    state.currentCedula = Object.assign({}, data);
  },
  FILL_ESTADOS({ context }, estados) {
    state.estados = estados;
  },
  FILL_MUNICIPIOS({ context }, municipios) {
    state.municipios = municipios;
  },
  UPDATE_CURRENT_CEDULA({ context }, updatedCedula) {
    state.currentCedula = Object.assign({}, updatedCedula);
  }
};
export const actions = {
  CONSULTAR_CEDULAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.consultarCedula(data)
        .then(response => {
          if (response.data.msg == 'No Data') {
            commit("DATA_NOT_FOUND", data);
          }
          commit("SET_LOADING", false);
          commit("RESULT_CEDULAS", response.data.cedulas);
          commit("COUNT_CEDULAS", response.data.count);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  VALIDAR_CEDULA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.validarCedula(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.saveCedula(data)
        .then(response => {
          // console.log("saving", response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          console.log("erro in save", error);
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  UPDATE({ commit }, data) {
    return new Promise((resolve, reject) => {
      ApiService.updateCedula(data)
        .then(response => {
          commit("SET_LOADING", false);
          let cedula = response.data.cedula
          // if(response.data.cedula.apellido_materno == 'null') cedula.apellido_materno = ''
          commit("UPDATE_CURRENT_CEDULA", cedula);
          resolve(response);
        })
        .catch(error => {
          console.log("erro in save", error);
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SHOW_CEDULA({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.mostrarCedula(id)
        .then(response => {
          let cedula = response.data.cedula
          commit("SET_LOADING", false);
          commit("SHOW_A_CEDULA", cedula)
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  PDF_CEDULA({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.pdfCedula(id)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SEND_PDF({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.sendPdf(id)
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  PDF_REGISTROS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.pdfRegistros(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_PDF_ACUSE({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.pdfAcuse(data)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  LIST_REGISTROS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.reporteCedulas(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("RESULT_CEDULAS", response.data.cedulas);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_ESTADOS({ commit }) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getEstados()
        .then(response => {
          commit("SET_LOADING", false);
          commit("FILL_ESTADOS", response.data);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_MUNICIPIOS({ commit }, estadoId) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.getMunicipios(estadoId)
        .then(response => {
          commit("SET_LOADING", false);
          commit("FILL_MUNICIPIOS", response.data);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};
export const getters = {
  listCedulas: state => state.resultCedula,
  countCedulas: state => state.countCedula,
  currentCedula: state => state.currentCedula,
  dataNotFound: state => state.dataNotFound,
  estados: state => state.estados,
  municipios: state => state.municipios
};
